module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-100italic.a22a0c5079a6c96f8b2555de66621d16.woff2";